import { render, staticRenderFns } from "./tickets-batch-picker.component.vue?vue&type=template&id=a7d22a66"
import script from "./tickets-batch-picker.component.vue?vue&type=script&lang=js"
export * from "./tickets-batch-picker.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports